import * as twgl from "twgl.js";
import {
  blurFragmentShader,
  blurVertexShader,
  ellipseFragmentShader,
  fragmentShader,
  roundedRectFragmentShader,
  textureFragmentShader,
  textureVertexShader,
  vertexShader,
} from "./shaders";

export function createShapeProgram(gl: WebGL2RenderingContext): twgl.ProgramInfo {
  return twgl.createProgramInfo(gl, [vertexShader, fragmentShader]);
}

export function createEllipseProgram(gl: WebGL2RenderingContext): twgl.ProgramInfo {
  return twgl.createProgramInfo(gl, [vertexShader, ellipseFragmentShader]);
}

export function createRoundedRectProgram(gl: WebGL2RenderingContext): twgl.ProgramInfo {
  return twgl.createProgramInfo(gl, [vertexShader, roundedRectFragmentShader]);
}

export function createTextureProgram(gl: WebGL2RenderingContext): twgl.ProgramInfo {
  return twgl.createProgramInfo(gl, [textureVertexShader, textureFragmentShader]);
}

export function createBlurProgram(gl: WebGL2RenderingContext): twgl.ProgramInfo {
  return twgl.createProgramInfo(gl, [blurVertexShader, blurFragmentShader]);
}
